import { ApiResourceBaseClass as o } from "./baseApiCalls.js";
const t = "subscription";
class a extends o {
  /**
   * Send a subscription upsell request.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/subscription/upsell`
   *
   * @returns {Promise<SuccessResponse>} A promise resolving to a success payload.
   */
  postSubscriptionUpsell = async () => {
    const { data: s } = await this.post(`${t}/upsell`);
    return s;
  };
  /**
   * Send a subscription down-sell request.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/subscription/downsell`
   *
   * @returns {Promise<SuccessResponse>} A promise resolving to a success payload.
   */
  postSubscriptionDownSell = async () => {
    const { data: s } = await this.post(`${t}/downsell`);
    return s;
  };
}
export {
  a as Subscription
};
